import { Expo, TimelineMax } from "gsap";
import * as Topics from "../Data/Topics";

export default abstract class CultureBackground extends PIXI.Container {
    protected _size?: PIXI.Point;
    protected _introTimeline?: TimelineMax;
    protected _outroTimeline?: TimelineMax;
    protected _subscriptions: any[];
    constructor() {
        super();
        this.visible = false;
        this._subscriptions = [
            PubSub.subscribe(Topics.GAME_PAUSED, this.onPause.bind(this)),
            PubSub.subscribe(Topics.GAME_UNPAUSED, this.onResume.bind(this)),
        ];
    }
    public onResize(pSize: PIXI.Point) {
        this._size = pSize;
    }
    public AnimateIn(pCallback: () => void, pDelay: number = 0): void {
        if (this._introTimeline !== undefined) {
            this._introTimeline.kill();
        }
        this._introTimeline = new TimelineMax();
        // this._introTimeline.clear();
        this._introTimeline
            .staggerFromTo(this.children, 0.5,
                {pixi: {positionY: -this._size!.y}},
                {pixi: {positionY: 0}, ease: Expo.easeIn},
                0.1,
                pDelay,
                pCallback,
            )
            .call(() => this._introTimeline = undefined)
            // .play(0, false)
        ;
    }

    public AnimateOut(): void {
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.kill();
        }
        this._outroTimeline = new TimelineMax();
        // this._outroTimeline.clear();
        this._outroTimeline
            .fromTo(this.children, 0.5,
                {pixi: {positionY: 0}},
                {pixi: {positionY: -this._size!.y}, ease: Expo.easeOut},
            )
            .call(() => this._outroTimeline = undefined)
            // .play(0, false)
        ;

    }

    protected onPause() {
        if (this._introTimeline !== undefined) {
            this._introTimeline.pause();
        }
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.pause();
        }
    }
    protected onResume() {
        if (this._introTimeline !== undefined) {
            this._introTimeline.resume();
        }
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.resume();
        }
    }
}
